import axios from 'axios';
import Store from '../../redux/Store';
import { logout } from '../../redux/Userslice';

// 🔐 Token Getter
const getToken = () => {
  try {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user).token : null;
  } catch {
    return null;
  }
};

// 🏢 Schema Getter
const getSchema = () => sessionStorage.getItem('schema') || null;

// 📦 Default Headers
export const headers = () => {
  const schema = getSchema();
  return {
    'Content-Type': 'application/json',
    ...(schema && { 'X-TenantID': schema }),
  };
};

// 🧾 JWT + FormData
export const headersForJwtWithFormdata = () => {
  const token = getToken();
  const schema = getSchema();
  return {
    ...(token && { 'Authorization': `Bearer ${token}` }),
    ...(schema && { 'X-TenantID': schema }),
  };
};

// 📄 PDF Download
export const headersForPDF = () => {
  const token = getToken();
  const schema = getSchema();
  return {
    ...(token && { 'Authorization': `Bearer ${token}` }),
    ...(schema && { 'X-TenantID': schema }),
    'responseType': 'blob',
  };
};

// 🔐 JWT + JSON
export const headersForJwtWithJson = () => {
  const token = getToken();
  const schema = getSchema();
  return {
    'Content-Type': 'application/json',
    ...(token && { 'Authorization': `Bearer ${token}` }),
    ...(schema && { 'X-TenantID': schema }),
  };
};

// 🌐 JWT + Query
export const headersForJwtQueryParam = () => {
  const token = getToken();
  const schema = getSchema();
  return {
    accept: '*/*',
    ...(token && { 'Authorization': `Bearer ${token}` }),
    ...(schema && { 'X-TenantID': schema }),
  };
};

// 🌍 Create Axios Instance
export const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

// 🧼 Global 401 Interceptor
axiosInstance.interceptors.response.use(
  response => response,
  error => {
    console.log("🧪 error.response:", error.response);

    if (!error.response) {
      console.error("❌ Network/CORS error");
      return Promise.reject(error);
    }

    if (error.response.status === 401) {
      console.warn("🔒 401 Unauthorized - Logging out...");
      Store.dispatch(logout());
      localStorage.clear();
      sessionStorage.clear();
      window.location.href = '/login';
    }

    return Promise.reject(error);
  }
);

